import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { ClipboardList, MapPin } from "lucide-react";
import { adminApi, errorMessage } from "../../lib/api";
import { inr } from "../landing/usePricing";

export const MyVacancies = ({ refresh }) => {
  const [items, setItems] = useState(null);
  const load = useCallback(() => {
    adminApi.get("/employer/listings").then((r) => setItems(r.data)).catch((e) => toast.error(errorMessage(e)));
  }, []);
  useEffect(() => { load(); }, [load, refresh]);
  const setStatus = (v, status) => {
    if (status === "filled" && !window.confirm(`Mark "${v.job_role}" as Filled? Employees will stop seeing this vacancy.`)) return;
    adminApi.post(`/employer/listings/${v.id}/status`, { status })
      .then(() => { toast.success(status === "filled" ? "Marked as Filled. Hidden from employees." : "Vacancy reopened"); load(); })
      .catch((e) => toast.error(errorMessage(e)));
  };
  if (!items) return null;
  return (
    <section data-testid="my-vacancies" className="space-y-4">
      <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-white"><ClipboardList className="h-5 w-5 text-orange-400" />My vacancies
        <span className="text-base font-normal text-slate-500">({items.filter((v) => v.status === "open").length} open)</span></h2>
      {items.length === 0 && <p className="text-slate-500">No vacancies posted yet.</p>}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((v) => (
          <article key={v.id} data-testid={`my-vacancy-${v.id}`} className={`flex flex-col rounded-2xl border bg-[#0F172A] p-5 ${v.status === "filled" ? "border-white/10 opacity-75" : "border-emerald-500/40"}`}>
            <div className="flex items-start justify-between gap-2">
              <p className="font-semibold text-white">{v.job_role}</p>
              <span data-testid={`my-vacancy-status-${v.id}`} className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs font-bold ${v.status === "filled" ? "bg-slate-500/15 text-slate-500" : "bg-emerald-500/10 text-emerald-500"}`}>
                {v.status === "filled" ? "Filled" : "Open"}
              </span>
            </div>
            <p className="flex items-center gap-1 text-sm text-slate-400"><MapPin className="h-3.5 w-3.5 text-red-500" />{v.district}, {v.state}</p>
            <p className="mt-2 text-sm text-slate-400">{v.headcount} openings · {inr(v.pay_amount)}/{v.pay_type === "daily" ? "day" : "mo"} · {v.applications} applications</p>
            <p data-testid={`my-vacancy-joined-${v.id}`} className="text-sm font-semibold text-emerald-500">{v.joined} / {v.headcount} joined (OTP){v.auto_filled ? " · auto-filled" : ""}{v.auto_reopened && v.status === "open" ? " · reopened (employee left)" : ""}</p>
            <p className="font-mono text-[11px] text-slate-500">{v.reference}</p>
            {v.status === "filled" ? (
              <button onClick={() => setStatus(v, "open")} data-testid={`my-vacancy-reopen-${v.id}`} className="mt-4 rounded-lg border border-white/15 py-2 text-sm font-semibold text-slate-300 hover:border-orange-500">Reopen</button>
            ) : (
              <button onClick={() => setStatus(v, "filled")} data-testid={`my-vacancy-fill-${v.id}`} className="mt-4 rounded-lg bg-emerald-600 py-2 text-sm font-semibold text-white hover:bg-emerald-700">Mark as Filled</button>
            )}
          </article>
        ))}
      </div>
    </section>
  );
};
